const tableTitleServiceType = {
  title: 'Tipos de Servicios',
  placeholder: 'Buscar por tipo de servicio',
  Typography: 'Ningún resultado encontrado'
};

export default tableTitleServiceType;
